(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskReferenceEdit',
	};

	var form_id = 'taskreferenceedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.TaskManager.initTaskForm(form_id);

		// changing the task classification
		$('#' + form_id + 'classification').change(function onClassificationChange(e)
		{
			Adzuki.TaskManager.classificationFieldChange(form_id);
		});

		// changing the due date based on for a classification
		$('#' + form_id + 'due_based_on').change(function onDueDateBasedChange(e)
		{
			Adzuki.TaskManager.dueBasedOnFieldChange(form_id);
		});

		// when changing the reservation_id, check if the reservation selected
		// is cancelled, and update the "Based On" options accordingly
		$('#' + form_id + 'reservation_id').change(function onReservationIdChange(e)
		{
			Adzuki.TaskManager.populateDueDateBasedOn(form_id, 'reservation');
		});
	};

	form.success = function success(response)
	{
		var task_id = $('#' + form_id + 'id').val();
		var $modal  = $('.modal');

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		Adzuki.StatusMessage('success', 'The task reference has been saved.', 'Success', {
			onClose: function onAlertClosed() {
				$('#task-details-nav').data('changed', 1);

				Adzuki.TaskManager.renderTaskListView(task_id);
				Adzuki.TaskManager.renderTaskReferenceView(task_id);

				// if we tied the task to a stand-alone task list, let's move
				// to the "Task List" tab, since the information is there
				if (
					response['data']['classification'] === null
					&& response['data']['task_list_id'] !== null
				) {
					$('#task-task-list-tab a').trigger('click');
				}

				// update the task details form with the new details
				Adzuki.Ajax.get('/Tasks/viewTaskDetails/' + task_id)
					.then(function viewTaskDetails(response) {
						$modal.find('#task-details').html(response);

						Adzuki.Form.initAjaxForm('TaskAddEdit');
					});
			}
		});
	};
}(jQuery, window.Adzuki || {}));
